export enum ObjectType {
  Building = 'building',
  Tower = 'tower',
  Room = 'room',
}
